import * as React from 'react';
import { OrderSummarySection } from './order-summary-section';
import StaticData, { StaticDataGroup } from 'ted-ui/build/StaticData';
import { IOrderDetailsProps } from '@applications/order-tracker/config/order-tracker-new-common/types'

export const CustomerDetailsSection = ({orderSummary}: IOrderDetailsProps) => {
    const getGroupOfDescs = (): React.ReactNode =>
        (
            <StaticDataGroup id="customer-details-group-data">
                <StaticData
                    id="static-data-test"
                    name="Customer"
                    value={orderSummary.customerName}
                />
                <StaticData
                    id="static-data-test"
                    name="Customer ID"
                    value={orderSummary.cidn}
                />
            </StaticDataGroup>
        );
    return (
        <OrderSummarySection
            title="Customer details"
            descriptionGroup={getGroupOfDescs()}
        />
    )
};
